import { render } from "./AllCases.vue?vue&type=template&id=0ed88e9e"
import script from "./AllCases.vue?vue&type=script&lang=js"
export * from "./AllCases.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/cases/AllCases.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0ed88e9e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0ed88e9e', __exports__)) {
    console.log('reload')
    api.reload('0ed88e9e', __exports__)
  }
  
  module.hot.accept("./AllCases.vue?vue&type=template&id=0ed88e9e", () => {
    console.log('re-render')
    api.rerender('0ed88e9e', render)
  })

}


export default __exports__